import { SupportFolderSchema } from "@redotech/redo-model/support-folder";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateSupportFolder = {
  name: "updateSupportFolder" as const,
  input: z.object({
    folderId: zExt.objectId(),
    name: z.string().min(1).max(255).optional(),
    viewIds: z.array(zExt.objectId()).optional(),
    defaultViews: z.array(z.string()).optional(),
  }),
  output: SupportFolderSchema.nullable(),
};
